import { RegionsDataInterface } from '~/src/repositories/regions/regions.repository';
import {
    DropdownRegionsItem,
} from '~/src/components/blocks/clients-request/organization-info/components/dropdown-regions-item/dropdown-regions-item';
import type {
    PrepareDataType,
} from '~/src/components/blocks/clients-request/organization-info/organization-info.types';

export const getRegionComponentItem = (data: RegionsDataInterface[] | []): JSX.Element[] => {
    return (
        data.map((elem, key) => (
            <DropdownRegionsItem key={elem?.id + String(key)} {...elem} />
        ))
    );
};

export const prepareDataFromDropdownRegions: PrepareDataType<RegionsDataInterface> = ({ data, callback }) => {
    return data.map((item) => ({
        id: String(item.id),
        value: item?.name,
        Component: callback(data),
    }));
};
